/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import Account from './Account';
import Person from './Person';

/**
 * The RegistrationRequest model module.
 * @module model/RegistrationRequest
 * @version v0
 */
export default class RegistrationRequest {
  /**
   * Constructs a new <code>RegistrationRequest</code>.
   * @alias module:model/RegistrationRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>RegistrationRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RegistrationRequest} obj Optional instance to populate.
   * @return {module:model/RegistrationRequest} The populated <code>RegistrationRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RegistrationRequest();
      if (data.hasOwnProperty('account'))
        obj.account = ApiClient.convertToType(data['account'], 'String');
      if (data.hasOwnProperty('accountStatusToStartWith'))
        obj.accountStatusToStartWith = ApiClient.convertToType(data['accountStatusToStartWith'], 'Number');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('oid'))
        obj.oid = ApiClient.convertToType(data['oid'], 'String');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
      if (data.hasOwnProperty('firstname'))
        obj.firstname = ApiClient.convertToType(data['firstname'], 'String');
      if (data.hasOwnProperty('lastname'))
        obj.lastname = ApiClient.convertToType(data['lastname'], 'String');
      if (data.hasOwnProperty('permissions'))
        obj.permissions = ApiClient.convertToType(data['permissions'], 'String');
      if (data.hasOwnProperty('currencyCode'))
        obj.currencyCode = ApiClient.convertToType(data['currencyCode'], 'String');
      if (data.hasOwnProperty('customToken'))
        obj.customToken = ApiClient.convertToType(data['customToken'], 'String');
      if (data.hasOwnProperty('dbAccount'))
        obj.dbAccount = Account.constructFromObject(data['dbAccount']);
      if (data.hasOwnProperty('dbPerson'))
        obj.dbPerson = Person.constructFromObject(data['dbPerson']);
    }
    return obj;
  }
}

/**
 * @member {String} account
 */
RegistrationRequest.prototype.account = undefined;

/**
 * @member {Number} accountStatusToStartWith
 */
RegistrationRequest.prototype.accountStatusToStartWith = undefined;

/**
 * @member {String} email
 */
RegistrationRequest.prototype.email = undefined;

/**
 * @member {String} oid
 */
RegistrationRequest.prototype.oid = undefined;

/**
 * @member {String} password
 */
RegistrationRequest.prototype.password = undefined;

/**
 * @member {String} firstname
 */
RegistrationRequest.prototype.firstname = undefined;

/**
 * @member {String} lastname
 */
RegistrationRequest.prototype.lastname = undefined;

/**
 * @member {String} permissions
 */
RegistrationRequest.prototype.permissions = undefined;

/**
 * @member {String} currencyCode
 */
RegistrationRequest.prototype.currencyCode = undefined;

/**
 * @member {String} customToken
 */
RegistrationRequest.prototype.customToken = undefined;

/**
 * @member {module:model/Account} dbAccount
 */
RegistrationRequest.prototype.dbAccount = undefined;

/**
 * @member {module:model/Person} dbPerson
 */
RegistrationRequest.prototype.dbPerson = undefined;

